import { Image, Wrapper } from './splash_screen.styles';

import logo from '../static/icons/logo.svg';

export default function SplashScreen() {
  return (
    <Wrapper>
      <Image alt="Rewardo" src={logo} />
    </Wrapper>
  );
}
